import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";

import type { LoadOrganizationEstimateFulfilled } from "../types";
import type { Organization } from "@packages/client";
import type { AsyncThunkOptionType } from "Reducers/types";

export const loadOrganizationEstimate = createAsyncThunk<
  LoadOrganizationEstimateFulfilled | undefined,
  { organization: Organization },
  AsyncThunkOptionType
>(
  "app/organizations/load_org_estimate",
  async ({ organization }, { rejectWithValue }) => {
    try {
      const estimateResultCurrent = await organization.getEstimate({
        current_month: true,
        format: "complex"
      });
      const estimateResultFuture = await organization.getEstimate({
        format: "complex"
      });

      return {
        current: estimateResultCurrent,
        future: estimateResultFuture,
        organizationId: organization.name
      };
    } catch (error) {
      if (![404, 403, 400].includes((error as { code: number }).code)) {
        logger(error, {
          action: "loadOrganizationEstimate",
          error
        });
      }

      rejectWithValue(error);
    }
  },
  {
    condition: ({ organization }): boolean => {
      return !!organization;
    }
  }
);
